<template>
  <div class="form-group and-or-rule col-xs-12">
    <div class="col-xs-3">
      <label class="sr-only">{{ $t('pubGicSet.SelectFieldName') }}</label>
      <a-select
        v-model="flName"
        style="width: 100%"
        @change="changeFlname"
        size="small"
        showSearch
        optionFilterProp="children"
        :filterOption="filterOption"
      >
        <a-select-option
          v-for="option in options.fieldNameSel"
          :value="option.uid"
          >{{ option.key }}</a-select-option
        >
      </a-select>
    </div>

    <div class="col-xs-2" v-if="flName != ''">
      <a-select
        v-model="operator"
        style="width:100%"
        placeholder="Select Condition"
        size="small"
        @change="operatorChange"
        showSearch
        optionFilterProp="children"
        :filterOption="filterOption"
      >
        <a-select-option
           :disabled="option.dataValue == 'in' || option.dataValue == 'not in' "
          v-for="option in options.condition"
          :value="option.dataValue"
          >{{ option.dataValue }}</a-select-option
        >
      </a-select>
    </div>

    <div class="col-xs-3" v-if="flType == 'String' && operator != 'Is Not Empty' && operator != 'Is Empty' && statusType != 'Status'">
      <a-input
        type="text"
        v-model="textSearchval"
        placeholder="search Text"
        size="small"
      />
    </div>

    <div class="col-xs-3" v-if="operator == 'between' && flType != 'Date' && flType != 'Datetime'">
      <a-input
        type="text"
        v-model="ConditionTypeTextVal"
        placeholder="search Text"
        size="small"
      />
    </div>

    <!--时间 operator == between -->
    <div class="col-xs-6" v-if="flType == 'Date' || flType == 'Datetime' && operator == 'between'">
      <a-range-picker
        size="small"
        @change="onChangeTimePicker"
        :format="flType == 'Datetime' ? ' YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'"
        :show-time="{
          hideDisabledOptions: true,
          defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
        }"
      />
    </div>

    <div class="col-xs-3" v-if="flType == 'Date' || flType == 'Datetime' && operator != 'between' && operator != 'like' && operator != 'Is Not Empty' && operator != 'Is Empty'">
      <a-date-picker size="small" @change="onChangeTimeTs" :format="flType == 'Datetime' ? ' YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD'" />
    </div>

    <div class="col-xs-2" v-if="flType == Boolean">
      <a-switch v-model="BooleanVal" size="small" />
    </div>

    <div class="col-xs-2" v-if="flType == 'Integer' || flType == 'Decimal'">
      <a-input-number
        v-model="numVal"
        :precision="flType == 'Integer' ? 0.1 : 1"
        style="width: 100%"
        size="small"
      />
    </div>

    <div class="col-xs-2" v-if="flType == 'Long'">
      <a-input-number
        v-model="numVal"
        :precision="flType == 'Long' ? 0.1 : 1"
        style="width: 100%"
        size="small"
      />
    </div>

    <div class="col-xs-3" v-if="flType == 'DROP'">
      <a-select
              v-model="textSearchval"
              style="width:100%"
              placeholder="Select Status"
              size="small"
              showSearch
              optionFilterProp="children"
              :filterOption="filterOption"
              @dropdownVisibleChange="dropdownVisibleChange"
      >
        <a-select-option v-for="item in selectlist" :value="item.key">{{item.value}}</a-select-option>
      </a-select>
    </div>

      <a-popconfirm
              :title="$t('generic.AreyoudeleTask')"
              :okText="$t('generic.Yes')"
              :cancelText="$t('generic.No')"
              @confirm="deleteSelf"
      >
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{ $t('generic.Delete') }}</span>
          </template>
          <img class="sbxs" src="../../../../assets/img/ss-delete.png" width="22" height="22" style="margin-left: 4px">
        </a-tooltip>
      </a-popconfirm>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from "vuex";
import ajax from '../../../../api/ajax'
import api from '../../../../api/url'
export default {
  name: "rule",
  props: ["options"],
  data() {
    return {
      flType: "", // 选择类型显示后面输入类型
      ConditionTypeTextVal: "",
      flName: "",
      operator: "",
      textSearchval: "",
      timeValue: '',
      boolValue: false,
      numVal: null,
      statusType: '',
      selectlist: [],
      required: false, // 是否必填
    };
  },
  computed: {
      ...mapState(["lang"]),
  },
  created() {},
  methods: {
      dropdownVisibleChange(val){
         if(val){
              let tt =  this.options.fieldNameSel
              let item = null;

              for(let i in tt){
                  if(tt[i].detailUid == this.flName){
                      item = tt[i];
                      break;
                  }
              }

           let params = {
                  language: this.lang
              };
              params.gmcUid = item.pattern.gmcUid

              if( item.codeGroup != undefined && item.codeGroup != null  && item.codeGroup.trim().length > 0    ){
                 params.gmcUid =  item.gmcUid;
                 params.codeGroup = item.codeGroup;
              }

       
              ajax.post(api.GETSELECTARRAY, params).then(res=>{
                 this.selectlist = res.data
              })
          }
      },
      filterOption(input, option) {
          return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      operatorChange(){
          this.timeValue = ''
      },
      changeFlname(val) {
        this.numVal = "";
        this.operator = this.options.condition[0].dataValue;
        this.options.fieldNameSel.forEach((v, i) => {
          if (v.detailUid == val) {
              if(v.type =='POPUP'){
                  this.flType = 'String'
              }else{
                  this.flType = v.type;
              }
              this.textSearchval = ''
//              if(v.fieldName == 'Status'){
//                  this.statusType = 'Status'
//                  return
//              }else{
//                  this.statusType = ''
//                  this.textSearchval = ''
//              }
          }
      });
    },
      moment,
      onChangeTimePicker(date, dateString) {
        this.timeValue = dateString;
      },
      onChangeTimeTs(val){
        let v = ''
          if(this.flType== "Datetime"){
              v = moment(val).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.flType == "Date") {
              v =  moment(val).format('YYYY-MM-DD')
          }
          this.timeValue = [v]
      },
      deleteSelf() {
        this.$emit("delete-rule");
      },
      queryFormStatus() {
        let time = this.timeValue
        if(this.timeValue.length > 0){
            time = this.timeValue[0] + '@##@' + (this.timeValue[1] == undefined ? this.timeValue[0] : this.timeValue[1])
        }
        let obj = {
            flName: this.flName,
            operator: this.operator,
            textSearchval: this.textSearchval + "@##@" + this.ConditionTypeTextVal,
            timeValue: time,
            boolValue: this.boolValue,
            numVal: this.numVal,
            flType: this.flType,
            required: this.required
        }
        return obj
    },

    fillRuleStatus(data) {
        this.flName = data.flName;
        this.operator = data.operator;
      if(this.operator == 'between'){
          let str = data.textSearchval;
          let textArr = str.split("@##@")
          this.textSearchval = textArr[0]
          this.ConditionTypeTextVal = textArr[1]
      }else{
          let str = data.textSearchval;
          this.textSearchval = str.split("@##@")[0]
      }
      this.timeValue = data.timeValue;
      this.boolValue = data.boolValue;
      this.numVal = data.numVal;
      this.flType = data.flType;
      this.required = data.required
    }
  }
};
</script>

<style>
.and-or-rule {
  position: relative;
  height: 30px;
  margin-left: 15px !important;
  padding-left: 0;
}
.form-group {
  padding-left: 0 !important;
}
.and-or-rule:before,
.and-or-rule:after {
  content: "";
  position: absolute;
  left: -1px;
  width: 16px;
  height: calc(50% + 15px);
  border-color: #c0c5e2;
  border-style: solid;
}

.and-or-rule:before {
  top: -15px;
  border-width: 0 0 2px 2px;
}

.and-or-rule:after {
  top: 50%;
  border-width: 0 0 0 2px;
}

.and-or-rule:last-child:after {
  border: none;
}
</style>
